import { forwardRef } from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { useTranslation } from 'react-i18next';

import Text from '../../../../shared/Text';
import { ButtonBase } from '../../../../shared/Button';
import { scrollToStep } from '../../utils/scrollTo';

export const StepContainer = forwardRef(
  (
    { children, id, title, description, stepNumber, hasShortBr, nextStep },
    ref,
  ) => {
    const { t } = useTranslation('campaigns');

    return (
      <StepCard id={id} ref={ref}>
        <LineBreak />
        <StepNumber>
          <Text variant="button">{stepNumber}</Text>
        </StepNumber>
        <Header>
          <Description color="black.100" variant="subtitle1">
            {title}
          </Description>
          <Text marginTop="5px" color="black.60" variant="subtitle2">
            {description}
          </Text>
        </Header>
        {hasShortBr && <ShortLineBreak />}
        {children && <Children>{children}</Children>}
        {nextStep && (
          <NextButton onClick={() => scrollToStep(nextStep)}>
            <RightArrow />
            {t('steps.nextButton')}
          </NextButton>
        )}
      </StepCard>
    );
  },
);

StepContainer.displayName = 'StepContainer';

const StepCard = styled.div`
  font-family: 'Montserrat', sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  margin: 0px auto;
  padding: 50px 0;
  text-align: center;
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  width: 750px;
`;

const StepNumber = styled.div`
  background: ${themeGet('colors.white')};
  border: 1px solid ${themeGet('colors.black.100')};
  border-radius: 50%;
  width: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Children = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const LineBreak = styled.div`
  width: 1px;
  height: 125px;
  background: linear-gradient(
    0deg,
    rgba(37, 40, 43, 0.3) 0%,
    rgba(37, 40, 43, 0) 100%
  );
  margin-bottom: 14px;
`;

const ShortLineBreak = styled(LineBreak)`
  height: 30px;
  background: ${themeGet('colors.black.100')};
  opacity: 0.2;
`;

const Description = styled(Text)`
  white-space: pre-line;
`;

const NextButton = styled(ButtonBase).attrs({
  mode: 'contained',
  variant: 'primary',
})`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 212px;
  margin: 100px 0;
`;

const RightArrow = styled.i.attrs({
  className: 'fa-solid fa-arrow-right',
})``;
